import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  action: "#",
  method: "POST"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "remember",
  value: "true"
}, null, -1);

const _hoisted_3 = ["placeholder"];
const _hoisted_4 = {
  class: "margin_top_30"
};
const _hoisted_5 = {
  class: "grid",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_6 = {
  class: "col"
};
const _hoisted_7 = {
  key: 0,
  for: "type1",
  style: {
    "font-size": "8px",
    "color": "#1E90FF"
  }
};
const _hoisted_8 = {
  key: 1,
  for: "type1",
  style: {
    "font-size": "8px",
    "color": "#fff"
  }
};
const _hoisted_9 = {
  class: "col"
};
const _hoisted_10 = {
  key: 0,
  for: "type2",
  style: {
    "font-size": "8px",
    "color": "#1E90FF"
  }
};
const _hoisted_11 = {
  key: 1,
  for: "type2",
  style: {
    "font-size": "8px",
    "color": "#fff"
  }
};
const _hoisted_12 = {
  class: "col"
};
const _hoisted_13 = {
  key: 0,
  for: "type3",
  style: {
    "font-size": "8px",
    "color": "#1E90FF"
  }
};
const _hoisted_14 = {
  key: 1,
  for: "type3",
  style: {
    "font-size": "8px",
    "color": "#fff"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioButton = _resolveComponent("RadioButton");

  return _openBlock(), _createElementBlock("form", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    class: "input_div",
    type: "",
    placeholder: '请输入' + _ctx.placeholder,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.username = $event),
    onKeydown: _cache[1] || (_cache[1] = (...args) => _ctx.input_key_down_handler && _ctx.input_key_down_handler(...args))
  }, null, 40, _hoisted_3), [[_vModelText, _ctx.username]])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
    class: "input_div",
    type: "password",
    placeholder: "请输入密码",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.password = $event),
    onKeydown: _cache[3] || (_cache[3] = (...args) => _ctx.input_key_down_handler && _ctx.input_key_down_handler(...args))
  }, null, 544), [[_vModelText, _ctx.password]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_RadioButton, {
    id: "type1",
    name: "type",
    value: 1,
    modelValue: _ctx.loginType,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.loginType = $event),
    style: {
      "margin-right": "6px"
    }
  }, null, 8, ["modelValue"]), _ctx.loginType === 1 ? (_openBlock(), _createElementBlock("label", _hoisted_7, "手机号码")) : (_openBlock(), _createElementBlock("label", _hoisted_8, "手机号码"))]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_RadioButton, {
    id: "type2",
    name: "type",
    value: 2,
    modelValue: _ctx.loginType,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.loginType = $event),
    style: {
      "margin-right": "6px"
    }
  }, null, 8, ["modelValue"]), _ctx.loginType === 2 ? (_openBlock(), _createElementBlock("label", _hoisted_10, "电子邮箱")) : (_openBlock(), _createElementBlock("label", _hoisted_11, "电子邮箱"))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_RadioButton, {
    id: "type3",
    name: "type",
    value: 3,
    modelValue: _ctx.loginType,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.loginType = $event),
    style: {
      "margin-right": "6px"
    }
  }, null, 8, ["modelValue"]), _ctx.loginType === 3 ? (_openBlock(), _createElementBlock("label", _hoisted_13, "QQ号码")) : (_openBlock(), _createElementBlock("label", _hoisted_14, "QQ号码"))])]), _createElementVNode("div", null, [_createElementVNode("button", {
    class: "margin_top_30 login_button",
    type: "button",
    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.login_button_clicked && _ctx.login_button_clicked(...args))
  }, " 登 录 ")])]);
}